import { render, staticRenderFns } from "./PageProvisionsStufenVerwaltung.vue?vue&type=template&id=2d80f794&scoped=true&"
import script from "./PageProvisionsStufenVerwaltung.vue?vue&type=script&lang=js&"
export * from "./PageProvisionsStufenVerwaltung.vue?vue&type=script&lang=js&"
import style0 from "./PageProvisionsStufenVerwaltung.vue?vue&type=style&index=0&id=2d80f794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d80f794",
  null
  
)

export default component.exports